import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Flex, Image } from 'ui/acro'
import styledComponents from 'styled-components'
import { css } from '@styled-system/css'
import { SearchCardTitle } from '../common/SearchCardTextStyles'

const InstructorImage = styledComponents(Image)`
${css({
  width: '100%',
  borderRadius: '50%',
  objectFit: 'cover',
  aspectRatio: '1/1'
})}
`

const InstructorResultCard = forwardRef(
  ({ carouselItem, htmlId, name, url, thumbnailImage, altText }, ref) => {
    return (
      <Flex
        id={htmlId}
        ref={ref}
        as='a'
        href={url}
        flexDirection='column'
        alignContent='center'
        className={carouselItem ? 'swiper-slide unstyled' : 'unstyled'}
      >
        <InstructorImage
          src={
            thumbnailImage === null
              ? `https://d28gwrkukqy4h7.cloudfront.net/users/ico-profile-default.png`
              : thumbnailImage
          }
          altText={altText}
        />

        {name && (
          <SearchCardTitle id='InstructorTitle' textAlign='center' mt='10px'>
            {name}
          </SearchCardTitle>
        )}
      </Flex>
    )
  }
)

InstructorResultCard.propTypes = {
  name: PropTypes.string.isRequired,
  htmlId: PropTypes.any,
  url: PropTypes.string.isRequired,
  thumbnailImage: PropTypes.string.isRequired,
  altText: PropTypes.string
}

export default InstructorResultCard
